// initVars.js

export function setHeaderHeight() {
    const header = document.querySelector('.app-header');
    if (header) {
        const headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
}

export function setFooterHeight() {
    const footer = document.querySelector('.app-footer');
    if (footer) {
        const footerHeight = footer.offsetHeight;
        document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
    }
}

// Vous pouvez ajouter d'autres fonctions similaires ici, par exemple :
export function setMainContentPadding() {
    const header = document.querySelector('.app-header');
    const footer = document.querySelector('.app-footer');
    const mainContent = document.querySelector('.main-content');
    if (header && mainContent) {
        const headerHeight = header.offsetHeight;
        mainContent.style.paddingTop = `${headerHeight}px`;
    }
    if (footer && mainContent) {
        const footerHeight = footer.offsetHeight;
        mainContent.style.paddingBottom = `${footerHeight}px`;
    }
}

// Fonction pour initialiser toutes les variables
export function initAllVars() {
    setHeaderHeight();
    setFooterHeight();
    setMainContentPadding();
    // Ajoutez d'autres appels de fonction au besoin
}